<template>
  <div v-if="showEvent && show" class="date">
    <div class="col">
      <p>
        <i class="fa fa-calendar"/>
        <NuxtTime :datetime="showEvent.startsAt" weekday="long" day="numeric" :locale="language.locale"/>
      </p>
      <p>
        <NuxtTime :datetime="showEvent.startsAt" month="long" year="numeric" :locale="language.locale"/>
      </p>
    </div>
    <div class="col">
      <p>
        <i class="fa fa-clock"/>
        <NuxtTime :datetime="showEvent.startsAt" hour="numeric" minute="numeric" :hour12="true" :locale="language.locale"/>
      </p>
    </div>
    <div class="col">
      <i class="fa fa-map-marker"/>
      <p>{{ show.location ? `${show.location.name}` : 'Virtual' }}</p>
      <p v-if="!show.isOnline && show.location">{{ show.location.address }}. {{ show.location?.locality }}
        <a href="" class="bt_showMap" @click.prevent="showMap = !showMap">{{ showMapText }}</a>
      </p>
    </div>
    <div v-if="showMap" class="map" style="display: block">
      <img :src="show.googleMapUrl" alt="map">
    </div>
    <p>{{show.description}}</p>
    <div class="card">
      <h5 v-if="false">{{ $t('soldout') }}</h5>
      <div v-else>
        <h2>Tickets disponibles</h2>
        <ticket-quantity-paid-shows
            ref="paidComponent"
            :show="show"
            :show-event="showEvent"
            :quantity-preference="possibleTicketQuantity"
            :show-price-id-preference="possibleShowPriceId"
            @on-update-price-id="(newPriceId) => {showPriceId = newPriceId}"
            @on-update-quantity="(newQuantity) => {ticketQuantity = newQuantity}"
            @on-update-total="(newTotal) => {total = newTotal}"
        />
        <div class="tickets">
          <p>Total: <strong>${{ total + ticketQuantity * selectedShowPriceFee }}</strong></p>
          <slot name="action"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import TicketQuantityPaidShows from './TicketQuantityPaidShows.vue'
import {defineComponent, type PropType} from 'vue'
import {getDay, getHour, getMonthAndYear} from '~/utils/DateHelper'
import type {
  ShowEventPublicOutput, ShowPublicOutput
} from '~/api/generated'

export default defineComponent({
  name: 'ShowPricingDetailComponent',
  components: {
    TicketQuantityPaidShows
  },
  props: {
    showEvent: Object as PropType<ShowEventPublicOutput>,
    show: Object as PropType<ShowPublicOutput>,
    enablePurchase: Boolean,
    possibleTicketQuantity: Number,
    possibleShowPriceId: Number,
    possibleDonatePrice: Number,
  },
  data() {
    return {
      showTickets: false,
      total: 0,
      showPriceId: undefined,
      ticketQuantity: 0,
      donatePrice: undefined,
      showMap: false,
      locale: '',
      language: useI18n()
    }
  },
  computed: {
    selectedShowPriceFee(): number {
      const possibleShowPrice = this.showEvent?.showPrices?.filter(
          (showPrice) => {
            return showPrice.id === this.showPriceId
          }
      );
      const price = possibleShowPrice[0];
      if (price?.priceIncludesPlatformFee) {
        return 0;
      }
      return price?.platformFee ?? 0;
    },
    existTickets() {
      return ! this.show?.soldOut
    },
    showMapText() {
      return this.showMap ? 'Cerrar mapa' : 'Ver mapa'
    },
    ticketPrice() {
      if (this.show.type === TYPE_FREE) {
        return 0;
      }
      if (this.show.type === TYPE_DONATE) {
        return this.$refs.donateComponent.ticketPrice;
      }

      return this.$refs.paidComponent.showPriceValue;
    },
    ticketFee(): number {
      const possibleShowPrice = this.showEvent?.showPrices?.filter(
          (showPrice) => {
            return showPrice.id === this.showPriceId
          }
      );
      const price = possibleShowPrice[0];
      if (price?.priceIncludesPlatformFee) {
        return 0;
      }
      return price?.platformFee ?? 0;
    },
  },
  mounted() {
    if (this.enablePurchase) {
      this.showTickets = this.enablePurchase
    }
    if (this.possibleDonatePrice) {
      this.donatePrice = this.possibleDonatePrice
    }
    if (this.possibleTicketQuantity) {
      this.ticketQuantity = this.possibleTicketQuantity
    }
    if (this.possibleShowPriceId) {
      this.showPriceId = this.possibleShowPriceId
    }
  },
  methods: {
    buildBuyUrl() {
      return `/shows/buy/${this.showEvent.show_id}?se=${this.showEvent.id}&sp=${this.showPriceId}&tq=${this.ticketQuantity}&dp=${this.donatePrice}`
    },
    getMinPrice(showPrices) {
      return Math.min(...showPrices.map(item => item.priceIncludesPlatformFee ? item.price + (item.platformFee ?? 0) : item.price))
    },
    addToTotal(value, price, priceId = null) {
      this.total = this.total + price
      this.showPriceId = priceId
      this.ticketQuantity = value
    },
    removeFromTotal(value, price, priceId = null) {
      this.total = this.total - price
      this.showPriceId = priceId
      this.ticketQuantity = value
    },
    formatMonthAndYear(dateString: string) {
      return getMonthAndYear(dateString)
    },
    formatDay(dateString: string) {
      return getDay((dateString))
    },
    formatHour(dateString: string) {
      return getHour((dateString))
    },
  },

})
</script>
<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.8s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0.3;
}

p::first-letter {
  text-transform: capitalize;
}
</style>
